import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAp0GhforZN6zYKUflmQW3rRpSjhtbyfXk",
  authDomain: "just-vide-internal.firebaseapp.com",
  projectId: "just-vide-internal",
  storageBucket: "just-vide-internal.firebasestorage.app",
  messagingSenderId: "437759601087",
  appId: "1:437759601087:web:3948404510a0152a69190a",
  measurementId: "G-6LM890JZS7",
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);

// const messaging = getMessaging(firebaseApp);

// export const requestPermission = async () => {
//   console.log("Requesting permission...");
//   try {
//     const permission = await Notification.requestPermission();
//     if (permission === "granted") {
//       const token = await getToken(messaging, {
//         vapidKey:
//           "BEKyV_4AU3xcFs1-wHj11hGXi4aeHbyh8lBalMwcZx8TpyEuDheOs2htG3WFUa4lFVvAK861JZTH7keBxnS1pKA",
//       });
//       console.log("Token:", token);
//       // send token to server
//     } else {
//       console.error("Permission not granted");
//     }
//   } catch (error) {
//     console.warn("get token catch error :", error);
//   }
// };

// export const onMessageListener = () =>
//   new Promise((resolve) => {
//     onMessage(messaging, (payload) => {
//       console.log("payload", payload);
//       // Show notification in the foreground
//       if (payload?.notification) {
//         new Notification(payload.notification.title, {
//           body: payload.notification.body,
//           icon: payload.notification.icon || "/logo192.png",
//         });
//       }
//       resolve(payload);
//     });
//   });

// export { messaging, getToken, onMessage };
